import { z } from 'zod';

/**
 * Schema de validação para criação/edição de datas especiais
 */
export const specialDateOperatingHoursFormSchema = z
  .object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Selecione uma data válida'),
    isClosed: z.boolean().default(false),
    startTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    endTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    hasLunchBreak: z.boolean().default(false),
    lunchStartTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    lunchEndTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    timeInterval: z.number().refine((val) => [15, 30, 45, 60].includes(val), 'Intervalo inválido').optional(),
    parallelAppointments: z.number().int().min(1, 'Mínimo 1 atendimento').max(10, 'Máximo 10 atendimentos').optional(),
    isActive: z.boolean().default(true),
    isGeelyCareWeekend: z.boolean().default(false),
  })
  .refine(
    (data) => data.isClosed || (!!data.startTime && !!data.endTime && !!data.timeInterval),
    { message: 'Horários são obrigatórios quando loja não está fechada', path: ['startTime'] }
  )
  .refine(
    (data) => !data.startTime || !data.endTime || data.startTime < data.endTime,
    { message: 'Horário de início deve ser anterior ao fim', path: ['endTime'] }
  )
  .refine(
    (data) => !data.hasLunchBreak || (!!data.lunchStartTime && !!data.lunchEndTime),
    { message: 'Horários de almoço são obrigatórios quando ativado', path: ['lunchStartTime'] }
  )
  .refine(
    (data) => {
      if (
        data.hasLunchBreak &&
        data.startTime &&
        data.endTime &&
        data.lunchStartTime &&
        data.lunchEndTime
      ) {
        return (
          data.startTime < data.lunchStartTime &&
          data.lunchStartTime < data.lunchEndTime &&
          data.lunchEndTime < data.endTime
        );
      }
      return true;
    },
    { message: 'Intervalo de almoço deve estar dentro do expediente', path: ['lunchEndTime'] }
  );

/**
 * Schema para query de datas especiais
 */
export const specialDateOperatingHoursQuerySchema = z.object({
  storeId: z.string().uuid(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
});

export type SpecialDateOperatingHoursFormData = z.infer<typeof specialDateOperatingHoursFormSchema>;
export type SpecialDateOperatingHoursQueryData = z.infer<typeof specialDateOperatingHoursQuerySchema>;
